import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OtpInput from 'react-otp-input';
import { connect } from 'react-redux';
import { validateRegisterOTP } from '../../operations/form-validation/formValidation';
import { bindActionCreators } from 'redux';
import { otpVerifyAction, resendOtp } from '../../actions/authAction';
import Input from "sushiweb/InputTypes/Input";
import Check from "sushiweb/Icons/all/Check";
import LeftTriangle from "sushiweb/Icons/all/LeftTriangle";
import * as symbols from '../../operations/symbols';
import OTPFieldComponent from './../core/OTPFieldComponent/OTPFieldComponent';

class OTPComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      otp: {
        fields: {
          otp: '',
        },
        errors: {
          otp: null
        }
      },
      validations: {
        otp: null,
      },
      allValidated: false,
      resetSetTimeout: false
    }
  }


  handleChange(type, field, value) {
    this.setState(prevState => ({
      [type]: {
        errors: {
          ...prevState[type].errors,
        },

        fields: {
          ...prevState[type].fields,
          [field]: value
        }


      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  beginValidation(type, field, value) {
    this.setState(prevState => ({
      validations: {
        ...prevState.validations,
        [field]: true
      }
    }), () => {
      this.validateThisField(type, field, value);
    })
  }

  validateThisField(type, field, value) {
    var errList = validateRegisterOTP(this.state[type]);
    var err = errList[field];
    this.setState(prevState => ({
      [type]: {
        ...prevState[type],
        errors: {
          ...prevState[type].errors,
          [field]: err
        }
      },
      allValidated: errList.isValidated
    }))
  }

  resendOtp(onCall) {
    let otpFields = {};
    otpFields.phoneNumber = this.props.phoneNumber
    this.setState({resetSetTimeout: true});
    setTimeout(() => {
      this.setState({resetSetTimeout: false});
    }, 15000);
    this.props.actions.resendOtp(otpFields)
  }

  onSubmitOTP(e) {
    e.preventDefault();
    let otpValidatedData = validateRegisterOTP(this.state.otp);
    if (!otpValidatedData.isValidated) {
      this.setState(prevState => ({
        otp: {
          ...prevState.otp,
          errors: otpValidatedData
        }
      }))
    } else {
      this.setState(prevState => ({
        otp: {
          ...prevState.otp,
          errors: {}
        }
      }), () => {
        let otpFields = this.state.otp.fields;
        otpFields.phoneNumber = this.props.phoneNumber
        this.props.actions.otpVerifyAction(otpFields);
      })

    }
  }

  render() {
    const { verifyOtpStatus, verifyOtpError, resendOtpStatus, resendOtpError } = this.props;
    return (
      <form onSubmit={(e) => this.onSubmitOTP(e)}>
        <div className="input-field-wrap">
          {/* <Input
            label="Enter OTP"
            type="text"
            name="otp"
            otp={'otp1'}
            icon={this.state.validations.otp ? this.state.otp.errors.otp ? null : <Check /> : null}
            iconColor="green"
            value={this.state.otp.fields.otp}
            onBlur={(e) => this.beginValidation('otp', 'otp', e)}
            errorMsg={this.state.validations.otp ? this.state.otp.errors.otp : null}
            onChange={(e) => this.handleChange('otp', 'otp', e)}
          /> */}
          {/* <OTPInput /> */}
          <OTPFieldComponent 
                digits={6} 
                onChange={(value) => this.handleChange('otp', 'otp', value)} 
                validateOTP={(value) => this.beginValidation('otp', 'otp', value)}
                errorMsg={this.state.validations.otp ? this.state.otp.errors.otp : null}
          />
        </div>
        <div className="btn-wrapper">
          <button type="submit" className={this.state.allValidated ? "btn btn-green" : "btn btn-disabled"}>
            Verify OTP
          </button>
          {
            verifyOtpStatus === symbols.STATUS_FAIL && <div className="mt-2 red-text">{verifyOtpError.error.message}</div>
          }
        </div>

        <div className="btn-wrapper mt-4">
          Didn't receive OTP?
          <br />
          {
            resendOtpStatus === symbols.STATUS_BEGIN ? 
            <span className="green-link">Sending...</span> :
            <React.Fragment>
            <span className={this.state.resetSetTimeout ? `green-link disabled` : `green-link pointer` } onClick={() => this.resendOtp()}>Resend OTP</span>
              {
                resendOtpStatus === symbols.STATUS_FAIL && <div className="mt-2 red-text">{resendOtpError.error.message}</div>
              }
            </React.Fragment>
          }
          <br />
          {
            resendOtpStatus === symbols.STATUS_DONE && <div className="mt-1">OTP has been sent to your phone</div>
          }
        </div>

        <div className="mt-7">
          <div className="light-line" />
          <span className="green-link" onClick={this.props.backToLogin}><LeftTriangle className="icon-color-green sushi-icon sushi-icon-align-neg icon-fs-14 vertical-align-top"/> &nbsp;Go Back</span>
        </div>
        {
          this.props.errors &&  this.props.errors.error ?
          <div className="error mt-1">{this.props.errors.error.message}</div> : null
        }
      </form>
    )
  }
}

const actions = { resendOtp, otpVerifyAction }
export default connect(
  state => ({
    verifyOtpError: state.statuses.verifyOtp.errors,
    verifyOtpStatus: state.statuses.verifyOtp.status,
    resendOtpError: state.statuses.resendOtp.errors,
    resendOtpStatus: state.statuses.resendOtp.status,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(OTPComponent);
